<ng-sidebar-container>
    <!-- <ng-sidebar *ngIf="sideBarShow" [(opened)]="sideBarOpen" (onOpened)="sideBarOpened()" position="right" [animate]="sideBarAnimate" [keyClose]="false"> -->
    <ng-sidebar *ngIf="sideBarShow" [(opened)]="sideBarOpen" position="right" [animate]="sideBarAnimate" [keyClose]="false">
      <div class="sidebar-fix" >
        <div *ngIf="selected!=null">
          <div class="h2">{{getProductName(selected)}}</div>
          <div style="text-align:right;width:100%;height:0"><div style="position:relative;bottom:33px;right:10px">
            <button class="nrk-button" (click)="copyToClipboard(getProductLink())">Copy Product Link</button>
            <button class="btn btn-default btn-sm" (click)="previousFinishedProduct()"><nb-icon icon="arrow-circle-left-outline"></nb-icon></button>
            <button class="btn btn-default btn-sm" (click)="nextFinishedProduct()"><nb-icon icon="arrow-circle-right-outline"></nb-icon></button>
          </div></div>
          <div>
            <span class="h4">{{selected.calcCode}}</span>
            <button class="nrk-button" style="pointer-events:initial;margin:0.5em 1em" (click)="copyToClipboard(selected.calcCode)">Copy Product Code</button>
          </div>
          <div><a class="base-product" [routerLink]="[]" (click)="gotoBaseProduct(selected)">
            {{getBaseProductString(selected.product)}}
          </a></div>
          <br />
          <ngx-doc-form-filter-select [disabled]="locked" title="Base Product [Trial]" [noBorder]="true" [(value)]="$any(selected).product" [options]="baseProductTrialOptions" (valueChange)="productChanged($event)"></ngx-doc-form-filter-select>
          <!-- <ngx-form-dropdown [disabled]="true" title="Type" [(value)]="selected.type" [options]="typeOptions" (valueChange)="typeChanged($event)"></ngx-form-dropdown> -->
          <ngx-form-dropdown [disabled]="true" title="Type" [(value)]="selected.type" [options]="typeOptions"></ngx-form-dropdown>
          <ngx-form-dropdown [disabled]="locked" title="Status" [(value)]="selected.status" [options]="statusOptions"></ngx-form-dropdown>

          <ngx-form-array-field [disabled]="locked" title="Customers" [options]="data.businessOptions" [(value)]="selected.customers" [allBusinessOption]="true" [placeholder]="'Select Customer'"></ngx-form-array-field>
          <ngx-form-array-field [disabled]="locked" title="Suppliers" [options]="data.businessOptions" [(value)]="selected.suppliers" [allBusinessOption]="true" [placeholder]="'Select Supplier'"></ngx-form-array-field>
          <ngx-form-text [disabled]="locked" [multiline]="1" title="Internal Name (Name Override)" [(value)]="selected.nameOverride"></ngx-form-text>
          <ngx-form-text [disabled]="locked" [multiline]="1" title="External Name (Customer Product Name)" [(value)]="selected.externalName"></ngx-form-text>
          <ngx-form-text [disabled]="locked" [multiline]="1" title="External Code (Customer Product Code)" [(value)]="selected.externalCode"></ngx-form-text>
          <ngx-form-text [disabled]="locked" [multiline]="1" title="OBIC Item Code" [(value)]="selected.obic"></ngx-form-text>
          <ngx-form-text [disabled]="locked" [multiline]="1" title="Public Remark (Line Item Text)" [(value)]="selected.publicRemark"></ngx-form-text>
          <!-- <ngx-form-dropdown *ngIf="!locked" title="HS Code Template" [(value)]="hsCodeTemplate" [options]="hsCodeOptions" (valueChange)="hsChanged($event)"></ngx-form-dropdown> -->
          <ngx-form-dropdown [disabled]="locked" title="HS Code" [(value)]="selected.hs" [options]="selected.type ? hsCodeElectroOptions : hsCodeEnergyOptions"></ngx-form-dropdown>
          <!-- <ngx-form-text [disabled]="locked" [multiline]="1" title="HS Code" [(value)]="selected.hs"></ngx-form-text> -->

          <ngx-form-text [disabled]="locked" *ngIf="selected.type != energyType && selected.content" [multiline]="1" title="Net Weight (kg)" [(value)]="$any(selected).machineryWeight"></ngx-form-text>

          <ngx-doc-form-filter-select [disabled]="locked || (selected.version > 1 || !selected.draft)" *ngIf="selected.type == energyType && selected.content" [noBorder]="true" title="Core" [value]="selected.content?.energy?.core?._id" (valueChange)="changeCore($event)" [options]="data.coreOptions"></ngx-doc-form-filter-select>
          <ngx-form-text [disabled]="locked || (selected.version > 1 || !selected.draft)" [multiline]="1" *ngIf="selected.type == energyType && selected.content" title="Width (mm)" [(value)]="$any(selected).content.energy.width"></ngx-form-text>
          <ngx-form-text [disabled]="locked || (selected.version > 1 || !selected.draft)" [multiline]="1" *ngIf="selected.type == energyType && selected.content" title="Roll Length (m)" [(value)]="$any(selected).content.energy.rollLength"></ngx-form-text>
          
          <ngx-form-text [disabled]="locked" *ngIf="selected.type == energyType && selected.content" [multiline]="1" title="Mica In/Out" [(value)]="selected.micaInOut"></ngx-form-text>
          <ngx-form-text [disabled]="locked" *ngIf="selected.type == energyType && selected.content" [multiline]="1" title="Finished Roll Winding Strength (N/cm)" [(value)]="selected.finishedRollWindingStrength"></ngx-form-text>
          <ngx-form-text [disabled]="locked" *ngIf="selected.type == energyType && selected.content" [multiline]="1" title="Joint Adhesive Tape Type" [(value)]="selected.jointTapeType"></ngx-form-text>
          <ngx-form-text [disabled]="locked" *ngIf="selected.type == energyType && selected.content" [multiline]="1" title="Joint Adhesive Tape Width" [(value)]="selected.jointTapeWidth"></ngx-form-text>
          <ngx-form-text [disabled]="locked" *ngIf="selected.type == energyType && selected.content" [multiline]="1" title="Joint Method" [(value)]="selected.jointMethod"></ngx-form-text>
          <ngx-form-text [disabled]="locked" *ngIf="selected.type == energyType && selected.content" [multiline]="1" title="Joint Location and Number Within the Roll" [(value)]="selected.jointLocation"></ngx-form-text>
          <ngx-form-text [disabled]="locked" *ngIf="selected.type == energyType && selected.content" [multiline]="1" title="Allowed Amount of Joints" [(value)]="selected.jointsWithinQuantification"></ngx-form-text>
          <ngx-form-text [disabled]="locked" *ngIf="selected.type == energyType && selected.content" [multiline]="1" title="Other Joint Requirements" [(value)]="selected.jointOtherRequirements"></ngx-form-text>
          
          <ngx-form-text [disabled]="locked" *ngIf="selected.type == energyType && selected.content" [multiline]="1" title="Core Labeling" [(value)]="selected.coreLabeling"></ngx-form-text>
          <ngx-form-text [disabled]="locked" *ngIf="selected.type == energyType && selected.content" [multiline]="1" title="Inside Packing Labeling" [(value)]="selected.insidePackingLabeling"></ngx-form-text>
          <ngx-form-text [disabled]="locked" *ngIf="selected.type == energyType && selected.content" [multiline]="1" title="Outside Carton Box Labeling" [(value)]="selected.outsideCartonBoxLabeling"></ngx-form-text>
          <ngx-form-text [disabled]="locked" [multiline]="1" title="Delivery Collie Labeling" [(value)]="selected.deliveryCollieLabeling"></ngx-form-text>
          <ngx-form-text [disabled]="locked" *ngIf="selected.type == energyType && selected.content" [multiline]="1" title="Specified Shelf Life Condition" [(value)]="selected.specifiedShelfLifeCondition"></ngx-form-text>
          <ngx-form-text [disabled]="locked" *ngIf="selected.type == energyType && selected.content" [multiline]="1" title="Required Test Parameters (Test Certificate)" [(value)]="selected.requiredTestParameters"></ngx-form-text>

          <!-- <ngx-form-dropdown [disabled]="locked" *ngIf="selected.type == energyType && selected.content" title="Packing specs" [(value)]="selected.packing" (valueChange)="onPackingChanged($event)" [options]="packingOptions"></ngx-form-dropdown> -->

<!--          <ngx-form-dropdown [disabled]="locked" *ngIf="selected.type == energyType && selected.content" title="Carton size" [(value)]="selected.cartonSize[0]" (valueChange)="selected.packing = null" [options]="cartonSizeOptions"></ngx-form-dropdown>
          <ngx-form-text [disabled]="locked" *ngIf="selected.type == energyType && selected.content" [multiline]="1" title="Number of pieces per carton box" [(value)]="$any(selected).piecesPerCarton[0]"></ngx-form-text>
-->

         <div class="row" *ngIf="selected.type == energyType && selected.content && selected.cartonSize?.length">
            <div class="col-md-4"><label>Carton Size</label></div>
            <div class="col-md-8">
              <div class="form-group">
                <div class="row mt-1">
                  <div class="ml-3" style="padding-right:3rem">1: <ngx-doc-form-dropdown mode="integer" [disabled]="locked" [(value)]="selected.cartonSize[0]" (valueChange)="selected.packingSpec[0] = null; cartonSizeChanged($event, 0)" [options]="cartonSizeOptions"></ngx-doc-form-dropdown></div>
                  <div class="ml-3" style="padding-right:3rem">2: <ngx-doc-form-dropdown mode="integer" [disabled]="locked" [(value)]="selected.cartonSize[1]" (valueChange)="selected.packingSpec[1] = null; cartonSizeChanged($event, 1)" [options]="cartonSizeOptions"></ngx-doc-form-dropdown></div>
                  <div class="ml-3" style="padding-right:3rem">3: <ngx-doc-form-dropdown mode="integer" [disabled]="locked" [(value)]="selected.cartonSize[2]" (valueChange)="selected.packingSpec[2] = null; cartonSizeChanged($event, 2)" [options]="cartonSizeOptions"></ngx-doc-form-dropdown></div>
                </div>
              </div>
            </div>
          </div>

          <div class="row" *ngIf="selected.type == energyType && selected.content && selected.piecesPerCarton?.length">
            <div class="col-md-4"><label>Number of Pieces per Carton Box</label></div>
            <div class="col-md-8">
              <div class="form-group">
                <div class="row mt-1">
                  <div class="ml-3">1: <ngx-doc-form-texfield mode="integer" [disabled]="locked" [(value)]="selected.piecesPerCarton[0]"></ngx-doc-form-texfield></div>
                  <div class="ml-3">2: <ngx-doc-form-texfield mode="integer" [disabled]="locked" [(value)]="selected.piecesPerCarton[1]"></ngx-doc-form-texfield></div>
                  <div class="ml-3">3: <ngx-doc-form-texfield mode="integer" [disabled]="locked" [(value)]="selected.piecesPerCarton[2]"></ngx-doc-form-texfield></div>
                </div>
              </div>
            </div>
          </div>

          <div class="row" *ngIf="selected.type == energyType && selected.content && selected.packingSpec?.length">
            <div class="col-md-4"><label>Packing Spec</label></div>
            <div class="col-md-8">
              <div class="form-group">
                <div class="row mt-1">
                  <div class="ml-3" style="padding-right:3rem">1: <ngx-doc-form-dropdown mode="integer" [disabled]="locked" [(value)]="selected.packingSpec[0]" [options]="packingSpecOptions[0]"></ngx-doc-form-dropdown></div>
                  <div class="ml-3" style="padding-right:3rem">2: <ngx-doc-form-dropdown mode="integer" [disabled]="locked" [(value)]="selected.packingSpec[1]" [options]="packingSpecOptions[1]"></ngx-doc-form-dropdown></div>
                  <div class="ml-3" style="padding-right:3rem">3: <ngx-doc-form-dropdown mode="integer" [disabled]="locked" [(value)]="selected.packingSpec[2]" [options]="packingSpecOptions[2]"></ngx-doc-form-dropdown></div>
                </div>
              </div>
            </div>
          </div>
          
  
          <ngx-form-dropdown [disabled]="locked" title="First Priority of Box Label" [(value)]="selected.boxLabelPriority" [options]="boxLabelPriorityOptions"></ngx-form-dropdown>
          <ngx-form-dropdown [disabled]="!!selected.product?.countryOfOrigin || locked" title="Country of Origin" [value]="selected.product?.countryOfOrigin || selected.countryOfOrigin" [options]="countryOptions" (valueChange)="selected.countryOfOrigin = $event"></ngx-form-dropdown>
          <ngx-form-text [disabled]="locked" [multiline]="1" title="Remark" [(value)]="selected.remark"></ngx-form-text>
          <ngx-form-text [disabled]="true" [multiline]="1" title="Internal Code" [(value)]="selected.code" [disabled]="true"></ngx-form-text>

          <div class="row" *ngIf="selected.type == energyType">
            <div class="col-md-4"><label>Exclude From Inventory</label></div>
            <div class="col-md-8">
              <div class="form-group">
                <div class="row mt-1 ml-2">
                  <ngx-doc-form-checkbox title="Exclude from Inventory" [(value)]="selected.excludeFromInventory"></ngx-doc-form-checkbox>
                </div>
              </div>
            </div>
          </div>

          <!-- ======================================================= files ================================================================== -->
          <div class="file-upload">
            <ngx-form-upload *ngIf="getTDS($any(selected).product)?.length" [disabled]="true" [hideComment]="false" [hideCheckbox]="false" accept="application/pdf" class="file-upload-comp" title="TDS (Technical Datasheet)" url="/api/v1/upload" [files]="getTDS($any(selected).product)"></ngx-form-upload>
            <ngx-form-upload [disabled]="locked" [hideComment]="false" [hideCheckbox]="false" moveToText="Move to Spec" (moveTo)="moveFilesToSpec($event)" accept="application/pdf" class="file-upload-comp" title="Attached Files" url="/api/v1/upload" [(files)]="selected.files"></ngx-form-upload>
            <!-- <div *ngIf="selected.files.length && !locked"><button class="nrk-button" (click)="moveFilesToSpec()">move Attached files to customer product specification</button></div> -->
            <br>
            <ngx-form-upload 
              [disabled]="locked" 
              [hideComment]="false" 
              [hideCheckbox]="false" 
              additionalFieldLabel="Revision" 
              additionalDateLabel="Date of Release" 
              accept="application/pdf" 
              class="file-upload-comp" 
              title="Customer Product Specification" 
              url="/api/v1/upload" 
              [(files)]="selected.customerProductSpecification">
            </ngx-form-upload>
            <br>
            <ngx-form-upload 
              [disabled]="locked" 
              [hideComment]="false" 
              accept="image/jpeg" 
              class="file-upload-comp" 
              title="Customer Identificator" 
              url="/api/v1/upload" 
              [preview]="true"
              [(file)]="selected.customerIdentificator">
            </ngx-form-upload>
          </div>

          <!-- ======================================================= versions ================================================================== -->
          <br />
          <div class="row">
            <div class="col-md-4"><label>Versions</label></div>
            <div class="col-md-8">
              <div class="form-group versions">
                <div *ngFor="let item of getVersions(selected)">
                  <button [ngClass]="{'nrk-doc-button': true, 'version-active': item.version == selected.version}" (click)="switchToVersion(item)">{{item.version-1}}</button>
                </div>
              </div>
            </div>
          </div>
          <br />

          <!-- ======================================================= changelog ================================================================== -->
          <div class="row" *ngIf="selected.changelog.length > 0">
            <div class="col-md-4"><label>Changelog</label></div>
            <div class="col-md-8">
              <div class="form-group">
                <ngx-changelog [abstractItem]="selected" [print]="false" [disabled]="locked"></ngx-changelog>
              </div>
            </div>
          </div>
          <br />

          <!-- <ngx-form-text [disabled]="locked" [multiline]="1" title="Changelog comment" [(value)]="changelog"></ngx-form-text> -->

          <br />
          <br />
          <br />

        </div>
      </div>

      <div class="sidebar footer" *ngIf="selected">
        <div *ngIf="!isPreview" style="display:flex;align-items:center;justify-content:center;">
            <button *ngIf="fromWizard" class="btn btn-md btn-default" title="Back to Finished Product Overview" 
              (click)="cancel(selected)">
              <i class="ion-arrow-left-a"></i>
            </button>
            <button *ngIf="!fromWizard" class="btn btn-default btn-md" (click)="cancel(selected)">Close</button>
            <button *ngIf="!readOnly && (locked && canUnlock()) && isFirstVersion()" class="btn btn-primary btn-md" (click)="edit()">Edit</button>
            <button *ngIf="!readOnly && (locked && canUnlock())" class="btn btn-primary btn-md" (click)="lock(false)">{{isFirstVersion ? 'New version' : 'Unlock'}}</button>
            <button *ngIf="!readOnly && !locked" class="btn btn-primary btn-md" (click)="save(selected)">Save</button>
            <button *ngIf="!readOnly && !locked && selected.draft" class="btn btn-danger btn-md" (click)="cancelDraft(selected)">Cancel Draft</button>
            <button *ngIf="!readOnly && !locked" class="btn btn-info btn-md" (click)="save(selected, true)">Save Draft</button>
            <button *ngIf="!readOnly && selected?._id" class="btn btn-info btn-md" (click)="create(selected, true)">Clone</button>
            <!-- <button class="btn btn-info btn-lg" (click)="pdfPreview(selected)">PDF preview</button> -->
            <button class="btn btn-info btn-md" (click)="isPreview=true">Download</button>
            <button *ngIf="(fromWizard && compilation.issuer === 2) || (!fromWizard && !readOnly && !selected?.draft && canUnlock())" 
              class="btn btn-info btn-md" (click)="priceMatrix(selected, 'nrka')">Price Matrix NRKA</button>
            <button *ngIf="(fromWizard && compilation.issuer === 3) || (!fromWizard && !readOnly && !selected?.draft && canUnlock())"
              class="btn btn-info btn-md" (click)="priceMatrix(selected, 'nrkg')">Price Matrix NRKG</button>
            <button *ngIf="fromWizard" class="btn btn-primary btn-md" (click)="setFinishedProduct()" [attr.disabled]="!selected._id || null">Add to Line Item</button>
            <button class="btn btn-default btn-md" (click)="loadData(true)" title="refresh data"><i class="ion-refresh"></i></button>
            <button *ngIf="fromWizard " class="btn btn-md btn-info" title="go to price matrix" 
            (click)="compilation.issuer === 3 ? priceMatrix(selected, 'nrkg') : priceMatrix(selected, 'nrka')">
              <i class="ion-arrow-right-a"></i>
            </button>
        </div>
        <div *ngIf="isPreview" style="display:flex;align-items:center;justify-content:center;">
          <button class="btn btn-default btn-md" (click)="isPreview=false">Back</button>
          <button class="btn btn-info btn-md" (click)="pdfPreview(selected, downloadType.document)">Document</button>
          <!-- <button class="btn btn-info btn-md" (click)="pdfPreview(selected, downloadType.merged)">Merge document with attachments</button> -->
          <button class="btn btn-info btn-md" (click)="pdfPreview(selected, downloadType.zipMerged)">ZIP (Document & Attachments)</button>
          <button class="btn btn-info btn-md" (click)="pdfPreview(selected, downloadType.zipAttachments)">ZIP (Attachments Only)</button>
          <button class="btn btn-info btn-md" (click)="pdfPreview(selected, downloadType.document); pdfPreview(selected, downloadType.zipAttachments)">PDF + ZIP</button>
        </div>
      </div>

    </ng-sidebar>

    <div ng-sidebar-content>
      <ngx-page-container>
        <h1>Finished Product</h1>
        <hr>

        <div *ngIf="!readOnly" class="create">
          <button class="btn btn-primary btn-sm pull-right" (click)="create()">+</button>
        </div>
        <div class="status-bu">
          <div>
            <div>
              Status
              <ngx-doc-form-dropdown class="fullwidth" [options]="statusFilterOptions" [(value)]="statusFilter"></ngx-doc-form-dropdown>
            </div>
            <div>
              Business Unit
              <ngx-doc-form-dropdown class="fullwidth" [options]="buFilterOptions" [(value)]="buFilter"></ngx-doc-form-dropdown>
            </div>
          </div>
        </div>
        
        <div class="mx-auto"><pagination-controls (pageChange)="p = $event"></pagination-controls></div>

        <table class="table table-hover">
          <thead>
          <tr>
            <th *ngFor="let col of columns; let idx = index;" class="pseudo-link" (click)="onSort(col.id)">
              {{col.name}}<span *ngIf="sort.column === col.id">&nbsp;{{sort.dir > 0 ? '▲' : '▼'}}</span></th>
            <th style="text-align:center">
              <span style="padding-right:1.5em;padding-left:0.5em" title="Technical datasheet">TDS</span><span>Enabled</span>
            </th>
          </tr>
          <tr>
            <th *ngFor="let col of columns" scope="col">
              <ngx-doc-form-texfield class="fullwidth noborder" [value]="col.search" (keyupChange)="col.search=$event">
            </ngx-doc-form-texfield></th>
            <th style="text-align: center"><button class="nrk-button" (click)="clearFilter()">Clear Filter</button></th>
          </tr>
          </thead>
          <tbody>
              <tr *ngFor="let item of filter() | paginate: { itemsPerPage: 10, currentPage: p }"
                [ngClass]="{ 'table-warning nrk-disabled-background': item.disabled, 'table-info': item.draft && !item.disabled, 'table-success': !item.disabled && !item.draft, 'table-template': +item.status === 5  }"
                (click)="select(item);initializecarton()">
                <td (click)="toggleSidebar(item)">{{getProductName(item)}}</td>
                <!-- <td (click)="toggleSidebar(item)">{{getCalcCode(item)}}</td> -->
                <td (click)="toggleSidebar(item)">{{item.calcCode}}</td>
                <td><a [routerLink]="[]" (click)="gotoBaseProduct(item)"> 
                  {{getBaseProductString(item.product)}}
                </a></td>
                <!-- <td (click)="toggleSidebar(item)">{{getTypeString(item)}}</td> -->
                <td (click)="toggleSidebar(item)">
                  <ngx-form-array-field title="Customers" [editor]="false" [options]="data.businessOptions" [value]="item.customers"></ngx-form-array-field>
                </td>
                <td (click)="toggleSidebar(item)">
                  <ngx-form-array-field title="Suppliers" [editor]="false" [options]="data.businessOptions" [value]="item.suppliers"></ngx-form-array-field>
                </td>
                <!-- <td (click)="toggleSidebar(item)">{{item.hs}}</td> -->
                <td (click)="toggleSidebar(item)">{{item.externalCode}}</td>
                <td (click)="toggleSidebar(item)" [ngClass]="{'disabled': item.type == electroType}">{{item.type == energyType ? item.content?.energy?.width : ''}}</td>
                <td (click)="toggleSidebar(item)" [ngClass]="{'disabled': item.type == electroType}">{{item.type == energyType ? item.content?.energy?.rollLength : ''}}</td>
                <td (click)="toggleSidebar(item)" [ngClass]="{'disabled': item.type == electroType}">{{item.type == energyType ? getCoreString(item.content?.energy?.core?._id) : ''}}</td>
                <td (click)="toggleSidebar(item)">{{item.updatedAt | date : 'yyyy-MM-dd' }}</td>
                <td>
                  <div class="buttons">
                    <div>
                      <button *ngIf="getTDS(item.product)?.length" class="btn btn-default btn-md" (click)="downloadTDS(item.product)" title="Download Technical Datasheet"><i class="ion-arrow-down-a"></i></button>
                    </div>
                    <!-- <div>
                      <button class="btn btn-default btn-md" (click)="toggleSidebar(item)"><i class="ion-edit"></i></button>
                    </div> -->
                    <div *ngIf="!readOnly">
                      <!-- <ui-switch color="#308040A0" [(ngModel)]="!item.disabled" (change)="toggleDisable(item)"></ui-switch> -->
                      <form-ui-switch ngDefaultControl [value]="!item.disabled" (valueChange)="toggleDisable(item)" title="Enable / Disable Product"></form-ui-switch>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
        </table>
      </ngx-page-container>
    </div>
  </ng-sidebar-container>

  <div class="nrk-wizard-footer text-center">
    <button *ngIf="fromWizard" class="btn btn-md btn-default" title="Back to Base Product">
      <a [routerLink]="[]" (click)="gotoBaseProduct(finishedProduct)" class="pseudo-unlink"> 
        <i class="ion-arrow-left-a"></i>&nbsp;&nbsp;Back to base product
      </a>
    </button>
  </div>
